// extracted by mini-css-extract-plugin
export default {"usage-page__no-data":"Usage_usage-page__no-data__kGEY+","usage-page":"Usage_usage-page__ZqBEA"};